import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import FingoLogoPng from '../../assets/brand/images/logo_with_name.png';

function FingoLogo() {
  const navigate = useNavigate();
  return (
    <Box onClick={() => navigate('/')} width={120} sx={{ cursor: 'pointer' }}>
      <CardMedia
        component="img"
        image={FingoLogoPng}
        alt="logo"
        width="100%"
      />
    </Box>
  );
}

export default FingoLogo;
